import { useState } from "react";
import { record } from "@solimat/solimat-web-endpoint";

const useGetRoyalDecreeFormsCount = () => {
  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);
  const [loadingGetRoyalDecreeFormsCount, setLoadingGetRoyalDecreeFormsCount] =
    useState(false);
  const [successGetRoyalDecreeFormsCount, setSuccessGetRoyalDecreeFormsCount] =
    useState(false);
  const [errorGetRoyalDecreeFormsCount, setErrorGetRoyalDecreeFormsCount] =
    useState(null);
  const [royalDecreeFormsCount, setRoyalDecreeFormsCount] = useState<
    null | any
  >(null);

  const getRoyalDecreeFormsCount = (
    userId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetRoyalDecreeFormsCount(true);
    setSuccessGetRoyalDecreeFormsCount(false);
    apiRecord
      .getRoyalDecreeFormsCount(userId)
      .then((res: any) => {
        setLoadingGetRoyalDecreeFormsCount(false);
        setSuccessGetRoyalDecreeFormsCount(true);
        setRoyalDecreeFormsCount(res.data);
        if (typeof _cb === "function") {
          _cb(res.data);
        }
      })
      .catch((err: any) => {
        console.log(err);
        setLoadingGetRoyalDecreeFormsCount(false);
        setErrorGetRoyalDecreeFormsCount(err);
      });
  };
  return {
    royalDecreeFormsCount,
    getRoyalDecreeFormsCount,
    loadingGetRoyalDecreeFormsCount,
    successGetRoyalDecreeFormsCount,
    errorGetRoyalDecreeFormsCount,
  };
};
export default useGetRoyalDecreeFormsCount;